import React, { Component, Fragment } from 'react'
import Breadcrumbs from '../../shared/Breadcrumbs'
import { ProtectedOperationsRoute } from '../../routing'

export class ProtectedOperationsPage extends Component {
    render() {
        return (
            <Fragment>
            <Breadcrumbs />
            <ProtectedOperationsRoute />
          </Fragment>
        )
    }
}
